/* eslint no-nested-ternary: "off" */
/* eslint no-param-reassign: "off" */

import axios from 'axios';

import { AxiosError } from 'api/axios';
import { API_TIMEOUTS, apiBaseURL } from 'api/settings';
import * as errors from 'common/errors';

export default async function postSubscriberPreferences({
  jwt,
  subscribeTo = [],
  unsubscribeFrom = [],
  unsubscribeFromAll = false,
}: {
  jwt: string;
  subscribeTo?: string[];
  unsubscribeFrom?: string[];
  unsubscribeFromAll?: boolean;
}) {
  const config = {
    url: `${apiBaseURL()}/public/subscriberpreferencescenter`,
    method: 'POST',
    timeout: API_TIMEOUTS.S,
    headers: {
      'X-EBX-SubscriberPreferencesToken': jwt,
    },
    data: JSON.stringify({
      subscribeTo,
      unsubscribeFrom,
      unsubscribeFromAll,
    }),
  };

  try {
    const response = await axios(config);
    return response.data.campaigns;
  } catch (error) {
    const apiError =
      error instanceof AxiosError
        ? error.message
        : error instanceof Error
          ? // @ts-expect-error need to sort this out one day
            await errors.handleAPIError({ originalError: error })
          : error;
    throw apiError;
  }
}
